// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '아주약품',
  targetSheetName: '품목(세로)_수수료 추가표기',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '품목명',
    price: '보험약가',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '보험코드',
    '대표코드',
    '구분',
    '계열',
    '제품군별',
    '품목명',
    '성분명',
    '성분명(영문)',
    '보험약가',
    '위탁여부',
    '기본%',
    '고정%',
    '합산%',
    '기본%',
    '추가2%',
    '합산%',
    '비고',
  ],
});
